import React from 'react';
import { CartEmpty } from '@yme/assets/icons';
import { SVG } from '@yme/atoms/svg-icon';
import { useTranslation } from '@yme/services/i18n';
import { colorCoreBlack300 } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { RegularTextLevel2, RegularTextLevel4 } from '@yme/tokens/typography';
export const EmptyCart = () => {
    const { t } = useTranslation();
    return (React.createElement(FlexWrapper, { flexDirection: "column", alignItems: "center", padding: "12px 0", gap: "16px" },
        React.createElement(SVG, { src: CartEmpty, width: "120", height: "130" }),
        React.createElement(FlexWrapper, { alignItems: "center", flexDirection: "column", gap: "4px" },
            React.createElement(RegularTextLevel2, null, t('shoppingCart_emptyCart_title')),
            React.createElement(RegularTextLevel4, { color: colorCoreBlack300 }, t('shoppingCart_emptyCart_description')))));
};
